export default {
  methods: {
    loadMathml(flashcard) {
      if (!(flashcard && flashcard.id)) return;
      const json = JSON.stringify(flashcard);
      // check to see if mathml markup is in flashcard anywhere
      if (json.indexOf('<math') < 0) return;

      // if mathjax isn't loaded, load first then initiate
      // otherwise make sure it is defined then initiate
      // we do this because the update hook fires more than once so we make
      // make sure it doesn't fire again before script loads again
      const scriptId = 'mathmlscript';
      if (document.getElementById(scriptId)) {
        typeof(MathJax) !== 'undefined' && MathJax.Hub.Queue(['Typeset', MathJax.Hub]);
      } else {
        let script = document.createElement('script');
        script.id = scriptId;
        script.type = 'text/javascript';
        script.onload = function() {
          MathJax.Hub.Queue(['Typeset', MathJax.Hub]);
        };

        script.src = 'https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.5/MathJax.js?config=TeX-MML-AM_CHTML';
        document.getElementsByTagName('head')[0].appendChild(script);
      }
    },
  },
  mounted() {
    this.loadMathml(this.flashcard);
  },
  updated() {
    this.loadMathml(this.flashcard);
  },
};
